import React, { useState, useEffect } from 'react';

interface Props {}

const MobileLine: React.FC<Props> = ({}) => {
  return (
    <div className="self-stretch inline-flex justify-start items-center gap-4 mt-1">
      <div className="flex-1 h-0 outline outline-1 outline-offset-[-0.50px] outline-[#eeeeee]" />
      <div className="inline-flex flex-col justify-start items-start gap-4">
        <div className="inline-flex justify-center items-center gap-1">
          <div className="justify-start text-[#60646c] text-sm font-medium font-['Inter'] leading-snug">
            Choose a platform to view
          </div>
        </div>
      </div>
      <div className="flex-1 h-0 outline outline-1 outline-offset-[-0.50px] outline-[#eeeeee]" />
    </div>
  );
};

export default MobileLine;
